import { createContext } from "react";

const categoriesContext = createContext({
  categories: [],
  getCategories: (data) => {},
  getOneCategory: (id) => {},
});

export default categoriesContext;
